import React from 'react';
import { createBrowserRouter } from 'react-router-dom';
import { buildProtectedRouteChildren, legacyRedirectEntries } from './route-config.jsx';

/**
 * Builds the single `createBrowserRouter` tree for the app.
 *
 * @param {object} containers session-aware wrappers supplied by `App.jsx`:
 *   - `Login`: public `/login` element
 *   - `RootRedirect`: `/` element (auth-gated, migrates `tezus-route` once)
 *   - `ProtectedLayout`: authenticated shell element (children = protected routes)
 *   - `LegacyRedirectContainer`: `({ to }) => element` — auth-gated legacy path redirect
 */
export function createAppRouter({ Login, RootRedirect, ProtectedLayout, LegacyRedirectContainer }) {
  const legacyRedirectRoutes = legacyRedirectEntries.map(([from, to]) => ({
    path: from,
    element: <LegacyRedirectContainer to={to} />,
  }));

  return createBrowserRouter([
    { path: '/login', element: <Login /> },
    { path: '/', element: <RootRedirect /> },
    ...legacyRedirectRoutes,
    {
      element: <ProtectedLayout />,
      children: buildProtectedRouteChildren(),
    },
  ]);
}
